import * as s from "react";
import x from "react";
import { tablet as Q, mintelGray200 as O, mintelBlack as Z } from "mintel-tokens";
import { useMediaQuery as J } from "react-responsive";
import T from "classnames";
import { I as Y } from "./Icon-ByeAHRM4.es.js";
import { T as F } from "./index-BB-Wk85r.es.js";
import { u as ee } from "./ThemeProvider--i7ESlT5.es.js";
import { u as te } from "./DarkModeProvider-xoZXm3ct.es.js";
import { jsx as v, jsxs as ne, Fragment as oe } from "react/jsx-runtime";
import "react-dom";
import './CheckboxV2.css';function B(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function L(...e) {
  return (t) => {
    let n = !1;
    const c = e.map((o) => {
      const r = B(o, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let o = 0; o < c.length; o++) {
          const r = c[o];
          typeof r == "function" ? r() : B(e[o], null);
        }
      };
  };
}
function w(...e) {
  return s.useCallback(L(...e), e);
}
// @__NO_SIDE_EFFECTS__
function re(e) {
  const t = /* @__PURE__ */ ce(e), n = s.forwardRef((c, o) => {
    const { children: r, ...u } = c, i = s.Children.toArray(r), a = i.find(ie);
    if (a) {
      const l = a.props.children, f = i.map((d) => d === a ? s.Children.count(l) > 1 ? s.Children.only(null) : s.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...u, ref: o, children: s.isValidElement(l) ? s.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ v(t, { ...u, ref: o, children: r });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function ce(e) {
  const t = s.forwardRef((n, c) => {
    const { children: o, ...r } = n;
    if (s.isValidElement(o)) {
      const u = ue(o), i = ae(r, o.props);
      return o.type !== s.Fragment && (i.ref = c ? L(c, u) : u), s.cloneElement(o, i);
    }
    return s.Children.count(o) > 1 ? s.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var se = Symbol("radix.slottable");
function ie(e) {
  return s.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === se;
}
function ae(e, t) {
  const n = { ...t };
  for (const c in t) {
    const o = e[c], r = t[c];
    /^on[A-Z]/.test(c) ? o && r ? n[c] = (...i) => {
      const a = r(...i);
      return o(...i), a;
    } : o && (n[c] = o) : c === "style" ? n[c] = { ...o, ...r } : c === "className" && (n[c] = [o, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ue(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var le = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], I = le.reduce((e, t) => {
  const n = /* @__PURE__ */ re(`Primitive.${t}`), c = s.forwardRef((o, r) => {
    const { asChild: u, ...i } = o, a = u ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(a, { ...i, ref: r });
  });
  return c.displayName = `Primitive.${t}`, { ...e, [t]: c };
}, {});
function de(e, t = []) {
  let n = [];
  function c(r, u) {
    const i = s.createContext(u), a = n.length;
    n = [...n, u];
    const l = (d) => {
      const { scope: m, children: p, ...h } = d, k = m?.[e]?.[a] || i, _ = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ v(k.Provider, { value: _, children: p });
    };
    l.displayName = r + "Provider";
    function f(d, m) {
      const p = m?.[e]?.[a] || i, h = s.useContext(p);
      if (h) return h;
      if (u !== void 0) return u;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [l, f];
  }
  const o = () => {
    const r = n.map((u) => s.createContext(u));
    return function(i) {
      const a = i?.[e] || r;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: a } }),
        [i, a]
      );
    };
  };
  return o.scopeName = e, [c, fe(o, ...t)];
}
function fe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const c = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(r) {
      const u = c.reduce((i, { useScope: a, scopeName: l }) => {
        const d = a(r)[`__scope${l}`];
        return { ...i, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function D(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var E = globalThis?.document ? s.useLayoutEffect : () => {
}, me = s[" useInsertionEffect ".trim().toString()] || E;
function pe({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: c
}) {
  const [o, r, u] = he({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : o;
  {
    const f = s.useRef(e !== void 0);
    s.useEffect(() => {
      const d = f.current;
      d !== i && console.warn(
        `${c} is changing from ${d ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = i;
    }, [i, c]);
  }
  const l = s.useCallback(
    (f) => {
      if (i) {
        const d = be(f) ? f(e) : f;
        d !== e && u.current?.(d);
      } else
        r(f);
    },
    [i, e, r, u]
  );
  return [a, l];
}
function he({
  defaultProp: e,
  onChange: t
}) {
  const [n, c] = s.useState(e), o = s.useRef(n), r = s.useRef(t);
  return me(() => {
    r.current = t;
  }, [t]), s.useEffect(() => {
    o.current !== n && (r.current?.(n), o.current = n);
  }, [n, o]), [n, c, r];
}
function be(e) {
  return typeof e == "function";
}
function Ce(e, t) {
  return s.useReducer((n, c) => t[n][c] ?? n, e);
}
var U = (e) => {
  const { present: t, children: n } = e, c = ve(t), o = typeof n == "function" ? n({ present: c.isPresent }) : s.Children.only(n), r = w(c.ref, ke(o));
  return typeof n == "function" || c.isPresent ? s.cloneElement(o, { ref: r }) : null;
};
U.displayName = "Presence";
function ve(e) {
  const [t, n] = s.useState(), c = s.useRef(null), o = s.useRef(e), r = s.useRef("none"), u = e ? "mounted" : "unmounted", [i, a] = Ce(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const l = N(c.current);
    r.current = i === "mounted" ? l : "none";
  }, [i]), E(() => {
    const l = c.current, f = o.current;
    if (f !== e) {
      const m = r.current, p = N(l);
      e ? a("MOUNT") : p === "none" || l?.display === "none" ? a("UNMOUNT") : a(f && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, a]), E(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, d = (p) => {
        const k = N(c.current).includes(p.animationName);
        if (p.target === t && k && (a("ANIMATION_END"), !o.current)) {
          const _ = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = _);
          });
        }
      }, m = (p) => {
        p.target === t && (r.current = N(c.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      a("ANIMATION_END");
  }, [t, a]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: s.useCallback((l) => {
      c.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function N(e) {
  return e?.animationName || "none";
}
function ke(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function _e(e) {
  const t = s.useRef({ value: e, previous: e });
  return s.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function ye(e) {
  const [t, n] = s.useState(void 0);
  return E(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const c = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const r = o[0];
        let u, i;
        if ("borderBoxSize" in r) {
          const a = r.borderBoxSize, l = Array.isArray(a) ? a[0] : a;
          u = l.inlineSize, i = l.blockSize;
        } else
          u = e.offsetWidth, i = e.offsetHeight;
        n({ width: u, height: i });
      });
      return c.observe(e, { box: "border-box" }), () => c.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var S = "Checkbox", [ge, We] = de(S), [xe, A] = ge(S);
function Ne(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: c,
    defaultChecked: o,
    disabled: r,
    form: u,
    name: i,
    onCheckedChange: a,
    required: l,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: d
  } = e, [m, p] = pe({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: S
  }), [h, k] = s.useState(null), [_, b] = s.useState(null), C = s.useRef(!1), R = h ? !!u || !!h.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), P = {
    checked: m,
    disabled: r,
    setChecked: p,
    control: h,
    setControl: k,
    name: i,
    form: u,
    value: f,
    hasConsumerStoppedPropagationRef: C,
    required: l,
    defaultChecked: y(o) ? !1 : o,
    isFormControl: R,
    bubbleInput: _,
    setBubbleInput: b
  };
  return /* @__PURE__ */ v(
    xe,
    {
      scope: t,
      ...P,
      children: Ee(d) ? d(P) : c
    }
  );
}
var V = "CheckboxTrigger", z = s.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...c }, o) => {
    const {
      control: r,
      value: u,
      disabled: i,
      checked: a,
      required: l,
      setControl: f,
      setChecked: d,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: p,
      bubbleInput: h
    } = A(V, e), k = w(o, f), _ = s.useRef(a);
    return s.useEffect(() => {
      const b = r?.form;
      if (b) {
        const C = () => d(_.current);
        return b.addEventListener("reset", C), () => b.removeEventListener("reset", C);
      }
    }, [r, d]), /* @__PURE__ */ v(
      I.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": y(a) ? "mixed" : a,
        "aria-required": l,
        "data-state": G(a),
        "data-disabled": i ? "" : void 0,
        disabled: i,
        value: u,
        ...c,
        ref: k,
        onKeyDown: D(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: D(n, (b) => {
          d((C) => y(C) ? !0 : !C), h && p && (m.current = b.isPropagationStopped(), m.current || b.stopPropagation());
        })
      }
    );
  }
);
z.displayName = V;
var W = s.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: c,
      checked: o,
      defaultChecked: r,
      required: u,
      disabled: i,
      value: a,
      onCheckedChange: l,
      form: f,
      ...d
    } = e;
    return /* @__PURE__ */ v(
      Ne,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: r,
        disabled: i,
        required: u,
        onCheckedChange: l,
        name: c,
        form: f,
        value: a,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ ne(oe, { children: [
          /* @__PURE__ */ v(
            z,
            {
              ...d,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          m && /* @__PURE__ */ v(
            q,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
W.displayName = S;
var $ = "CheckboxIndicator", H = s.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: c, ...o } = e, r = A($, n);
    return /* @__PURE__ */ v(
      U,
      {
        present: c || y(r.checked) || r.checked === !0,
        children: /* @__PURE__ */ v(
          I.span,
          {
            "data-state": G(r.checked),
            "data-disabled": r.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
H.displayName = $;
var j = "CheckboxBubbleInput", q = s.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: c,
      hasConsumerStoppedPropagationRef: o,
      checked: r,
      defaultChecked: u,
      required: i,
      disabled: a,
      name: l,
      value: f,
      form: d,
      bubbleInput: m,
      setBubbleInput: p
    } = A(j, e), h = w(n, p), k = _e(r), _ = ye(c);
    s.useEffect(() => {
      const C = m;
      if (!C) return;
      const R = window.HTMLInputElement.prototype, M = Object.getOwnPropertyDescriptor(
        R,
        "checked"
      ).set, X = !o.current;
      if (k !== r && M) {
        const K = new Event("click", { bubbles: X });
        C.indeterminate = y(r), M.call(C, y(r) ? !1 : r), C.dispatchEvent(K);
      }
    }, [m, k, r, o]);
    const b = s.useRef(y(r) ? !1 : r);
    return /* @__PURE__ */ v(
      I.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: u ?? b.current,
        required: i,
        disabled: a,
        name: l,
        value: f,
        form: d,
        ...t,
        tabIndex: -1,
        ref: h,
        style: {
          ...t.style,
          ..._,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
q.displayName = j;
function Ee(e) {
  return typeof e == "function";
}
function y(e) {
  return e === "indeterminate";
}
function G(e) {
  return y(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Se = "CheckboxV2-module__container___vPmPc", Re = "CheckboxV2-module__dark___HItgp", Pe = "CheckboxV2-module__compere___XtwNR", we = "CheckboxV2-module__indicator___5HATV", Ie = "CheckboxV2-module__label___EtTzy", g = {
  container: Se,
  dark: Re,
  default: "CheckboxV2-module__default___BtMtS",
  compere: Pe,
  indicator: we,
  label: Ie
}, Ae = (e) => e === "indeterminate" ? "checkbox_mixed" : e ? "checkbox_checked" : "checkbox_unchecked", $e = ({
  value: e,
  onChange: t,
  id: n,
  label: c,
  disabled: o = !1,
  color: r = Z,
  className: u = "",
  labelClassName: i = "",
  ...a
}) => {
  const f = J({ maxWidth: Q }) ? F.Body2 : F.Body, d = ee(), m = te(), p = m ? "#FFFFFF33" : r;
  return /* @__PURE__ */ x.createElement(
    W,
    {
      checked: e,
      onCheckedChange: t,
      id: n,
      disabled: o,
      ...a,
      className: T(
        g.container,
        g[d],
        { [g.dark]: m },
        u
      )
    },
    /* @__PURE__ */ x.createElement(H, { forceMount: !0, className: g.indicator }, /* @__PURE__ */ x.createElement(
      Y,
      {
        name: Ae(e),
        size: "1.25rem",
        color: o ? O : p
      }
    )),
    !!c && /* @__PURE__ */ x.createElement(
      f,
      {
        responsive: !0,
        tagName: "label",
        htmlFor: n,
        color: o && O,
        className: T(g.label, i)
      },
      c
    )
  );
};
export {
  $e as C
};
